import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
    DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import { NavLink, useLocation } from "react-router";
import Pagination from "../../components/ui/Pagination";
import { useUI } from "../../context/UI";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { FaCheckCircle, FaClock, FaTimesCircle } from "react-icons/fa";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import ConfirmationModal from "../../components/ui/ConfirmationModal";
import CustomModal from "../../components/ui/CustomModal";

const CustomerTemplatePage = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(false);
    const location = useLocation();
    const { queryParams } = useQueryParams();
    const pageNo = queryParams.get("pageNo") || 0;
    const pageSize = queryParams.get("pageSize") || DEFAULT_PER_PAGE;
    const sortOrder = queryParams.get("sortOrder") || "DESC";
    const {
        setSegmentTitle,
        addToastMessage,
    } = useUI();
    const [controller, setController] = useState(null);
    const { selectedIds } = location.state || {};


    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const query = jsonToQueryParams({
                keyword: queryParams.get("search") || "",
            });
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/template?pageNo=${pageNo}&pageSize=${pageSize}&sortBy=createdAt&direction=${sortOrder}&${query}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListApi();
        setSegmentTitle("User");
    }, [location.search]);


    const handleMultipleDelete = async (templateId) => {
        // if (!customerId) {
        // 	addToastMessage({
        // 		status: false,
        // 		message: "Customer ID is not defined. Please try again.",
        // 	});
        // 	return;
        // }

        if (selectedIds.length === 0) {
            addToastMessage({
                status: false,
                message: `No user selected for sending notification.`,
            });
            return;
        }

        try {
            const response = await fetch(
                `${API_BASE_URL}/api/1.0.0/notification/notify`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-JWT-Assertion": localStorage.getItem("token"),
                    },
                    body: JSON.stringify({
                        includedUserIds: selectedIds,
                        templateId: templateId,
                        triggerForAll: false,

                    }),
                }
            );

            if (response.status === 200) {
                addToastMessage({
                    status: true,
                    message: `Notification has sent successfully.`,
                });
                // setShow(false);

                // setSelectedIds([]); // Clear selection
            } else {
                addToastMessage({
                    status: false,
                    message: `Something went wrong while sending notification. Please try again.`,
                });
            }
        } catch (error) {
            addToastMessage({
                status: false,
                message: `Something went wrong while sending notification. Please try again.`,
            });
        }
    };
    return (
        <>
            <PageMeta
                title={`Templates - ${DEFAULT_PAGE_TITLE}`}
                description={`Templates - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="flex justify-between items-center mb-6">
                <PageBreadcrumb
                    pageTitle="Template"
                />

            </div>

            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="space-y-6">
                    <div className="relative overflow-x-auto sm:rounded-lg">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 rounded-lg">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        Name
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        Subject
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Body
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Status
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.data.map((user, index) => (
                                    <tr key={index} className="border-b dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
                                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            <div className="flex items-center gap-2">
                                                {/* { */}
                                                <span>{`${user?.name}` || "-"}</span>
                                            </div>
                                        </td>
                                        {/* <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{user?.firstName + " " + user?.lastName}</td> */}
                                        <td className="px-6 py-4">{user?.subject}</td>
                                        <td className="px-6 py-4">{user?.body}</td>
                                        <td className="px-6 py-4">
                                            <div
                                                className={`flex items-center gap-2 text-xs px-3 py-1 rounded-full w-fit
                            ${user?.statusId === 1
                                                        ? 'bg-green-100 text-green-700'
                                                        : user?.statusId === 2
                                                            ? 'bg-red-100 text-red-700'
                                                            : 'bg-yellow-100 text-yellow-700'
                                                    }`}
                                            >
                                                {user?.statusId === 1 && <FaCheckCircle className="text-green-500" />}
                                                {user?.statusId === 2 && <FaTimesCircle className="text-red-500" />}
                                                {user?.statusId === 3 && <FaClock className="text-yellow-600" />}
                                                {user?.statusId === 1 ? "Active" : "Inactive"}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 flex gap-5">
                                            <NavLink to={`/template-details/${user?.id}`}>
                                                <button
                                                    type="submit"
                                                    className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 transition"
                                                >
                                                    View
                                                </button>
                                            </NavLink>
                                            <CustomModal
                                                selector={
                                                    <span>
                                                        <button
                                                            type="buttton"
                                                            className="edit-button"
                                                        >
                                                            Send
                                                        </button>
                                                    </span>
                                                }
                                                content={
                                                    <ConfirmationModal
                                                        onConfirm={async () => {
                                                            await handleMultipleDelete(user?.id);
                                                            return true;
                                                        }}
                                                        message={`Are you sure you want to send notification to this user?`}
                                                    />
                                                }
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <div className='flex justify-center items-center'>
                <Pagination
                    pageParam="pageNo"
                    currentPage={data?.pageNo + 1}
                    totalElements={data?.totalRecords}
                />
            </div>
        </>
    );
};
export default CustomerTemplatePage;
